/**
 * Contentkalender — ingang naar de socialplanner in het klantportaal (Flow).
 *
 * De kalender zelf (posts maken, plannen, feedback en akkoord van de klant) woont in
 * het portaal, zodat klant en team op dezelfde plek werken. Medewerkers loggen daar
 * met hun Microsoft-account in en zien alle klanten. Deze pagina wijst ernaartoe:
 * het teamoverzicht ("Vandaag voor jou") en de losse onderdelen.
 */
import { Box, Button, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PageHeader from '../../ui-components/PageHeader';

const ACCENT = { color: '#526075', bg: '#d5e3fd' };

// Zelfde omgevingskeuze als apiConfig: test en lokaal → test.flow, al het andere → productie.
const host = window.location.hostname;
const isTestOfLokaal = host === 'test.fullframe.nl' || host === 'localhost' || host === '127.0.0.1';
const PORTAAL_URL = isTestOfLokaal ? 'https://test.flow.fullframe.nl' : 'https://flow.fullframe.nl';

const ONDERDELEN = [
  {
    titel: 'Vandaag voor jou',
    tekst: 'Wat er over alle klanten heen actie vraagt: reacties van klanten, posts in interne check, akkoord dat nog ontbreekt vlak voor plaatsing.',
    pad: '/contentkalender?focus=actie',
    knop: 'Open overzicht',
  },
  {
    titel: 'Kalender per klant',
    tekst: 'Week- en maandweergave per klant. Vanuit het overzicht open je een klant; daar maak je ook nieuwe posts.',
    pad: '/contentkalender',
    knop: 'Kies een klant',
  },
];

export default function Contentkalender() {
  return (
    <Box sx={{ width: '100%', maxWidth: 1000, mx: 'auto', px: { xs: 2, sm: 3 }, pt: { xs: 3, md: 5 }, pb: 3 }}>
      <PageHeader
        icon="calendar_month"
        accent={ACCENT}
        title="Contentkalender"
        subtitle="Social posts plannen, intern checken en met de klant afstemmen · in het klantportaal"
        rightActions={
          <Button
            variant="contained"
            href={`${PORTAAL_URL}/contentkalender?focus=actie`}
            target="_blank"
            rel="noopener"
            endIcon={<OpenInNewIcon />}
          >
            Open contentkalender
          </Button>
        }
      />
      <Stack spacing={2} sx={{ mt: 3 }}>
        {ONDERDELEN.map((o) => (
          <Box
            key={o.titel}
            sx={{
              p: 2.5, border: 1, borderColor: 'divider', borderRadius: 2, bgcolor: 'background.paper',
              display: 'flex', gap: 2, alignItems: { xs: 'flex-start', sm: 'center' }, flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontWeight: 700 }}>{o.titel}</Typography>
              <Typography variant="body2" color="text.secondary">{o.tekst}</Typography>
            </Box>
            <Button variant="outlined" href={`${PORTAAL_URL}${o.pad}`} target="_blank" rel="noopener" endIcon={<OpenInNewIcon />}>
              {o.knop}
            </Button>
          </Box>
        ))}
        <Typography variant="body2" color="text.secondary">
          Je logt in het portaal in met je Microsoft-account. Klanten zien alleen hun eigen kalender en alleen posts
          die klaar zijn voor hun check.
        </Typography>
      </Stack>
    </Box>
  );
}
